import type { UserDTO } from "@/models/dtos/user-dto";
import { Role } from "@/models/enums/role";

export function getUserRoleFlags(user?: UserDTO, customerNumber?: string) {
  const isOneAdmin = !!user?.superAdmin;
  const isOneUser = !!user?.oneUser;
  const isOneUserAdmin = !!user?.roles.some(
    (r) => r.role === Role.ONE_USER_ADMIN,
  );
  const isCustomerAdmin = !!user?.roles.some(
    (r) =>
      r.role === Role.CUSTOMER_ADMIN && r.customerNumber === customerNumber,
  );
  const isUser = !!user?.roles.some(
    (r) => r.role === Role.USER && r.customerNumber === customerNumber,
  );

  return {
    isOneAdmin,
    isCustomerAdmin,
    isOneUserAdmin,
    isOneUser,
    isUser,
  };
}
